import {Component, forwardRef, Input} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {EmissionSource} from "@flowmaps-com/flowmaps-typescriptmodels";
import {AbstractValueAccessorComponent} from "../../../common/component/value-accessor.component";
import {sendQuery} from "../../../common/app-common-utils";

@Component({
  selector: 'app-sustainability-source-select',
  templateUrl: './sustainability-source-select.component.html',
  styleUrls: ['./sustainability-source-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SustainabilitySourceSelectComponent),
      multi: true
    }
  ]
})
export class SustainabilitySourceSelectComponent extends AbstractValueAccessorComponent<EmissionSource> {
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() connectionType?: string;

  private _value: EmissionSource;

  getSources = () => sendQuery("getEmissionSources", this.connectionType);

  get value(): EmissionSource {
    return this._value;
  }

  set value(value: EmissionSource) {
    this.writeValue(value);
  }

  writeValue(value: EmissionSource): void {
    this._value = value;
    this.onModelChange();
  }

  providerFormatter = (value: EmissionSource) => value ? `${value.name}` : null;
}
